import client from "../../client/client";

class ProductTourManagementService {
	getAllProductTours(cancelToken) {
		return client.get("/backoffice/producttour/all", { config: { cancelToken } });
	}

	updateProductTourList(productTourList, cancelToken) {
		return client.patch("/backoffice/producttour/producttours", {
			payload: productTourList,
			config: { cancelToken },
		});
	}

	getProductTourCompanies({ productTourId }, cancelToken) {
		return client.get(`/backoffice/producttour/${productTourId}/companies`, {
			config: { cancelToken },
		});
	}

	updateCompaniesForProductTour({ productTourId }, companyIds, cancelToken) {
		return client.patch(`/backoffice/producttour/${productTourId}/update/companies`, {
			payload: companyIds,
			config: { cancelToken },
		});
	}

	getCompanyProductTours({ companyId }, cancelToken) {
		return client.get(`/producttour/companies/${companyId}/producttours`, {
			config: { cancelToken },
		});
	}
}
export default new ProductTourManagementService();
